import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, NgbTooltipModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
